export default "__VITE_ASSET__BHJP$Kc0__"